<div class="confirm-dialog">
  <div class="confirm-header">{{ data.title || 'End Subscription' }}</div>
  <div class="confirm-body">
    <p>{{ data.message || 'Choose the date this subscription should end.' }}</p>
    <mat-form-field appearance="outline" class="end-date-field">
      <mat-label>End Date</mat-label>
      <input matInput [matDatepicker]="endPicker" [(ngModel)]="endDate">
      <mat-datepicker-toggle matIconSuffix [for]="endPicker"></mat-datepicker-toggle>
      <mat-datepicker #endPicker></mat-datepicker>
    </mat-form-field>
    <div *ngIf="errorMessage" class="end-date-error">
      {{ errorMessage }}
    </div>
  </div>
  <div class="confirm-actions">
    <button mat-button class="btn btn-secondary" (click)="cancel()" [disabled]="saving">Cancel</button>
    <button mat-raised-button color="primary" class="btn-primary" (click)="confirm()" [disabled]="!endDate || saving">{{ saving ? 'Saving…' : 'Confirm' }}</button>
  </div>
</div>
